<template>
  <div>
    <p class="tw:font-bold tw:mb-1">{{ label }}</p>
    <p class="tw:text-sm tw:mb-1">{{ $t('tbs_option_selection') }}</p>
    <ul class="tw:flex tw:flex-wrap">
      <li
        v-for="option in options"
        :class="type === 'flyout' ? 'flyout-item' : 'item'"
        class="tw:flex tw:items-center tw:text-sm"
        :key="`${option.id}-${value.map(v => v.id).join('-')}`"
      >
        <input
          type="checkbox"
          :name="name"
          :value="option.id"
          :id="`${name}_${option.id}`"
          :checked="isSelected(option)"
          :disabled="isDisabled(option)"
          @change="onSelect(option)"
          class="tw:cursor-pointer"
        />
        <label
          :for="`${name}_${option.id}`"
          class="tw:cursor-pointer tw:py-2 tw:m-0 tw:pl-3 tw:grow tw:flex tw:items-center tw:flex-wrap"
          >{{ $t(option.label) }}</label
        >
      </li>
    </ul>
  </div>
</template>
<script setup>
const emit = defineEmits(['onSelect'])
const onSelect = value => emit('onSelect', value)

const props = defineProps({
  name: { type: String, default: '' },
  label: { type: String, default: '' },
  options: { type: Array, default: () => [] },
  value: { type: Array, default: () => [] },
  type: { type: String, default: '' },
})

const isSelected = item => {
  return props.value.filter(option => option.id === item.id)?.length > 0
}
const isDisabled = product => {
  return props.value.length === 1 && props.value.some(item => item.id === product.id)
}
</script>
<style scoped>
.item {
  flex-basis: 100%;
  box-sizing: border-box;
}
.flyout-item {
  flex-basis: 50%;
}
</style>
